<template>
  <div class="bg-white py-20">
    <div class="pt-12 container">
      <div class="w-full">
        <div class="flex items-center">
          <p class="text-sm font-normal mr-1">Accomplishments</p>
          <feather-icon
            icon="ChevronRightIcon"
            class=""
            svgClasses="h-4 text-black"
          ></feather-icon>
          <p class="text-sm font-normal ml-1">Course Certificate</p>
        </div>
        <p class="mb-3 mt-2 font-light text-4xl">
          {{ certificateCourse.name }}
        </p>

        <div class="lg:flex">
          <div class="lg:w-1/2">
            <div class="w-full">
              <div
                class="
                  w-5/6
                  bg-f4f5f6
                  px-6
                  py-8
                  mr-auto
                  text-black
                  mt-6
                  rounded-md
                "
              >
                <div class="">
                  <span class="text-2xl font-normal">Completed by</span>
                  <span class="text-2xl font-bold">
                    {{ userData.firstname + " " + userData.lastname }}</span
                  >
                  <!-- <p class="text-sm font-bold pt-4 pb-1">September 30, 2020</p> -->
                  <p class="text-sm font-bold py-1">8-10 hours per week</p>
                  <!-- <p class="text-sm font-bold py-1">Grade Achieved: 100%</p> -->
                  <p class="pt-4 font-normal text-sm">
                    {{ userData.firstname + " " + userData.lastname }}'s account
                    is verified. Caregiver Saathi certifies their successful
                    completion of {{ certificateCourse.name }}
                  </p>
                </div>
              </div>
              <div class="flex mt-8">
                <!-- <img
                  src="../img/dashboard.png"
                  alt="dashboard"
                  class="h-24 w-24"
                /> -->
                <div class="ml-4 my-auto text-black">
                  <p class="text-lg font-bold underline">
                    {{ certificateCourse.name }}
                  </p>
                  <p class="text-sm font-normal py-1">
                    {{
                      certificateCourse.author
                        .map(
                          (x) => x.userId.firstname + " " + x.userId.lastname
                        )
                        .toString()
                    }}
                  </p>
                  <div class="flex items-center">
                    <!-- <div class="flex items-center">
                      <feather-icon
                        icon="StarIcon"
                        class=""
                        svgClasses="h-4 w-4 bg-f4f5f6"
                      ></feather-icon>
                      <feather-icon
                        icon="StarIcon"
                        class=""
                        svgClasses="h-4 w-4 bg-f4f5f6"
                      ></feather-icon>
                      <feather-icon
                        icon="StarIcon"
                        class=""
                        svgClasses="h-4 w-4 bg-f4f5f6"
                      ></feather-icon>
                      <feather-icon
                        icon="StarIcon"
                        class=""
                        svgClasses="h-4 w-4 bg-f4f5f6"
                      ></feather-icon>
                    </div> -->
                    <!-- <p class="text-sm font-normal ml-2">4.1 (38,400 ratings)</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lg:w-1/2">
            <!-- <div class="w-full">
              <div class="pm-certificate-container" ref="certificate">
                <div class="outer-border"></div>
                <div class="inner-border"></div>

                <div class="pm-certificate-border w-full">
                  <p class="text-center cursive text-2xl mt-6 font-medium">
                    CERTIFICATE OF COMPLETION
                  </p>
                  <div class="w-full text-center text-black pt-8 h270px">
                    <p class="font-semibold text-xl">
                      {{ userData.firstname + " " + userData.lastname }}
                    </p>
                    <hr class="w-3/5 mx-auto mt-2" />
                    <p class="pt-4 cursive text-xl font-medium">has earned</p>
                    <p class="pt-2 text-xl font-semibold">
                      {{ certificateCourse.duration }} Credit Hours
                    </p>
                    <p class="pt-6 cursive pt-4 text-xl font-medium px-6">
                      while completing the course entitled
                    </p>
                    <p class="mt-4 text-xl font-semibold px-6">
                      {{ certificateCourse.name }}
                    </p>
                    <hr class="mt-2 w-3/5 mx-auto" />
                  </div>
                  <div class="flex px-6 w-full justify-between mt-12">
                    <div class="w-56">
                      <div class="w-full text-center">
                        <p class="text-sm font-normal text-center">
                          CareGiverSaathi
                        </p>
                       
                        <img src="" alt="" class="h-12" />
                        <hr />
                        <p class="pt-2 font-semibold text-sm text-center">
                          Bhavana Issar <br />
                          Caregiver Saathi
                        </p>
                      </div>
                    </div>
                    <div></div>
                    <div class="w-56">
                      <div class="w-full text-center"></div>
                      <p class="text-sm font-normal text-center">
                        Date of Completion
                      </p>
                      <img src="" alt="" class="h-12" />
                      <hr />
                      <p class="pt-2 font-semibold text-sm text-center">
                        <br />
                        Social Security
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-8">
                <div class="flex">
                  <b-button variant="primary" class="py-2 px-8"
                    ><div class="flex items-center">
                      <feather-icon
                        icon="Share2Icon"
                        class=""
                        svgClasses="h-6 text-white"
                      ></feather-icon>
                      <p class="text-white text-base font-semibold ml-3">
                        Share Certificate
                      </p>
                    </div></b-button
                  >
                  <b-button class="ml-8 py-3 px-8" variant="outline-primary"
                    ><div class="flex items-center">
                      <feather-icon
                        icon="DownloadIcon"
                        class=""
                        svgClasses="h-6"
                      ></feather-icon>
                      <p class="ml-3 text-base font-semibold" @click="download">
                        Download Certificate
                      </p>
                    </div></b-button
                  >
                </div>
              </div>
            </div> -->
            <!-- <Certificate /> -->
            <div class="py-12" ref="certificate">
              <div class="flex">
                <div class="w-1/4">
                  <img
                    src="@/assets/images/certlogo.png"
                    class="w-full h-full"
                  />
                </div>
                <div class="text-center w-3/4 px-4">
                  <div class="flex justify-center mt-3">
                    <img
                      src="@/assets/images/clogo.png"
                      class="h-20 lg:h-auto"
                    />
                  </div>
                  <div class="">
                    <p
                      class="
                        mt-4
                        font-semibold
                        text-lightb
                        lg:text-xl
                        md:text-base
                        text-sm
                      "
                    >
                      CERTIFICATE OF COMPLETION
                    </p>
                    <p
                      class="
                        mt-4
                        font-medium
                        text-black
                        lg:text-xl
                        md:text-base
                        text-sm
                      "
                    >
                      This is awarded to
                    </p>
                    <p
                      class="
                        my-6
                        font-bold
                        lg:text-xl
                        md:text-base
                        text-sm text-black
                        uppercase
                      "
                    >
                      {{ userData.firstname + " " + userData.lastname }}
                    </p>
                    <p
                      class="
                        mt-4
                        font-medium
                        lg:text-xl
                        md:text-base
                        text-sm text-black
                        mx-auto
                      "
                    >
                      For completing the {{ certificateCourse.name }} for
                      respondent training organized by Caregiver Saathi.
                    </p>
                  </div>

                  <div class="flex justify-end mr-4 mt-6">
                    <div class="lg:w-2/4 w-2/5">
                      <img
                        src="@/assets/images/bhavana sign.png"
                        class="w-full object-none"
                      />
                      <p
                        class="
                          pt-2
                          font-semibold
                          text-sm text-center
                          borderblueb
                        "
                      >
                        <span class="text-primary"> BHAVANA ISSAR </span> <br />
                        <span class="text-lightb"> CEO and Founder </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-8">
              <div class="flex">
                <!-- <b-button variant="primary" class="py-2 px-8"
                  ><div class="flex items-center">
                    <feather-icon
                      icon="Share2Icon"
                      class=""
                      svgClasses="h-6 text-white"
                    ></feather-icon>
                    <p class="text-white text-base font-semibold ml-3">
                      Share Certificate
                    </p>
                  </div></b-button
                > -->
                <b-button class="py-3 px-8" variant="outline-primary"
                  ><div class="flex items-center">
                    <feather-icon
                      icon="DownloadIcon"
                      class=""
                      svgClasses="h-6"
                    ></feather-icon>
                    <p class="ml-3 text-base font-semibold" @click="download">
                      Download Certificate
                    </p>
                  </div></b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="hee hee"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
      </section>
    </vue-html2pdf> -->
</template>

<script>
import { jsPDF } from "jspdf";
import { mapState } from "vuex";
import "../../scss/index.scss";
export default {
  methods: {
    download() {
      const doc = new jsPDF({
        orientation: "potrait",
      });
      const pdf = this.$refs.certificate;

      doc.html(pdf, {
        callback: function (doc) {
          window.open(doc.output("bloburl"));
          // doc.save("certificate.pdf");
        },
        margin: [20, 5, 20, 5],
        html2canvas: { scale: 0.35 },
        x: 5,
        y: 10,
      });
    },
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("eLearning", ["certificateCourse"]),
  },
};
</script>
<style>
.cursive {
  font-family: "Pinyon Script", cursive;
}
.h270px {
  height: 270px;
}

.pm-certificate-container {
  position: relative;
  width: 800px;
  height: 600px;
  background-color: #618597;
  padding: 30px;
  color: #333;
  font-family: "Open Sans", sans-serif;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.outer-border {
  width: 794px;
  height: 594px;
  position: absolute;
  left: 50%;
  margin-left: -397px;
  top: 50%;
  margin-top: -297px;
  border: 2px solid #fff;
}

.inner-border {
  width: 730px;
  height: 530px;
  position: absolute;
  left: 50%;
  margin-left: -365px;
  top: 50%;
  margin-top: -265px;
  border: 2px solid #fff;
}

.pm-certificate-border {
  position: relative;
  width: 720px;
  height: 520px;
  padding: 0;
  border: 1px solid #e1e5f0;
  background-color: rgba(255, 255, 255, 1);
  background-image: none;
  left: 50%;
  margin-left: -360px;
  top: 50%;
  margin-top: -260px;
}

.pm-certificate-block {
  width: 650px;
  height: 200px;
  position: relative;
  left: 50%;
  margin-left: -325px;
  top: 70px;
  margin-top: 0;
}
</style>
